export default {"src":"/_next/static/media/brokenWindow_64.db08f329.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};